import type {
  BillingEntity,
  BillingEntityAPI,
  GetBillingEntitiesResponseAPI,
} from '@omnipresentgroup/types';

/**
 * Mappers
 */

const transformBillingEntityFromAPI = (
  billingEntity: BillingEntityAPI,
): BillingEntity => ({
  billingEntityId: billingEntity.billingEntityId,
  companyId: billingEntity.companyId,
  directDebitSetupUrl: billingEntity.directDebitSetupUrl,
  isDirectDebit: billingEntity.isDirectDebit,
  billingEntitiesInfo: {
    enrolledCurrencies: billingEntity.billingEntitiesInfo.enrolledCurrencies,
    formFlag: billingEntity.billingEntitiesInfo.formFlag,
    isDirectDebit: billingEntity.billingEntitiesInfo.isDirectDebit,
    isMultiBillingEntity:
      billingEntity.billingEntitiesInfo.isMultiBillingEntity,
  },
});

export const transformGetBillingEntitiesResponseFromAPI = (
  entities: GetBillingEntitiesResponseAPI,
): BillingEntity[] =>
  entities.map((entity) => transformBillingEntityFromAPI(entity));
